import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, BACKEND_URL } from "../lib/api";

const DEFAULTS = {
  legal_name: "Lux Madeira Services, Lda.",
  trade_name: "Lux Madeira Services",
  short_name: "Lux Madeira",
  slogan: "Cuidamos do seu conforto",
  nipc: "",
  address: "",
  postal_code: "",
  city: "Funchal",
  country: "Portugal",
  iban: "",
  bank: "",
  bic: "",
  mbway: "",
  phone: "+351 936 942 709",
  whatsapp: "+351 967 386 076",
  email: "luxstaymadeira@gmail.com",
  website: "www.luxstaymadeira.pt",
  logo_url: "/assets/luxstay-logo-circular.png",
  logo_dark_url: "/assets/luxstay-logo-white.png",
};

const CompanyContext = createContext({ company: DEFAULTS, reload: () => {} });

// Module-level mirror for plain-JS strings (share texts, WhatsApp messages…).
let CURRENT = DEFAULTS;
export const brand = () => CURRENT.trade_name || DEFAULTS.trade_name;
export const brandShort = () => CURRENT.short_name || brand();

/** Inline brand name that re-renders when the company config loads. */
export function Brand({ short = false }) {
  const { company } = useContext(CompanyContext);
  return <>{short ? (company.short_name || company.trade_name) : company.trade_name}</>;
}

export const resolveAsset = (path) =>
  path && path.startsWith("/api/") ? `${BACKEND_URL}${path}` : path;

export const fmtNipc = (n) => {
  const d = (n || "").replace(/\D/g, "");
  return d.length === 9 ? `${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6)}` : n || "";
};

export function CompanyProvider({ children }) {
  const [company, setCompany] = useState(DEFAULTS);
  const reload = useCallback(() => {
    api.get("/company/public")
      .then(({ data }) => {
        CURRENT = { ...DEFAULTS, ...data };
        setCompany(CURRENT);
      })
      .catch(() => {});
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return (
    <CompanyContext.Provider value={{ company, reload }}>
      {children}
    </CompanyContext.Provider>
  );
}

export function useCompany() {
  const { company, reload } = useContext(CompanyContext);
  return {
    company,
    reload,
    logo: resolveAsset(company.logo_url),
    logoDark: resolveAsset(company.logo_dark_url),
    digits: (v) => (v || "").replace(/\D/g, ""),
  };
}
